// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"9803c396","133":"2132e192","315":"b2c7b967","787":"3686ec6d","797":"3cd8b40d","815":"46986a4a"}[chunkId] + ".chunk.js";
};